<template>
  <div class="image-bank">
    <v-img
      v-if="flipAsset.images"
      :src="mainImage.mediumUri"
    >
    </v-img>
    <v-row
      v-if="flipAsset.images"
      dense
    >
      <v-col
        v-for="(image, i) in galleryImages"
        :key="i"
        cols="4"
      >
        <v-img :src="image.smallUri" v-on:click="openLightboxOnSlide(i+2)"></v-img>
      </v-col>
    </v-row>
     <FsLightbox
        :toggler="toggler"
        :slide="slide"
        :sources="lightboxImages"
        />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import FsLightbox from 'fslightbox-vue'

  export default {
    name: 'ImageBank',

    components: {
      FsLightbox
    },

    data() {
      return {
        toggler: false,
        slide: 1
      }
    },

    methods: {
      openLightboxOnSlide: function(number) {
        this.slide = number;
        this.toggler = !this.toggler;
      }
    },

    computed: {
      ...mapGetters([
        'flipAsset'
      ]),

      mainImage: function () {
        return this.flipAsset.images.find(i => i.type === 'mainImage')
      },

      galleryImages: function () {
        return this.flipAsset.images.filter(i => i.type === 'galleryImage')
      },

      lightboxImages: function () {
        if(typeof this.flipAsset.images !== 'undefined') {
          return this.flipAsset.images.map(i => i.largeUri)
        }
        return []
      }
    },
  }
</script>
